var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMainProducts = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 1.583,
    d: "M3.543 7.648c0-.648 0-.971.12-1.262.121-.291.35-.52.807-.978l.52-.52c.458-.457.687-.686.978-.807.29-.12.614-.12 1.262-.12h5.293c.647 0 .97 0 1.262.12.29.121.52.35.977.807l.52.52c.458.458.687.687.807.978s.12.614.12 1.262v5.021c0 1.493 0 2.24-.463 2.703-.464.464-1.21.464-2.703.464H6.71c-1.493 0-2.24 0-2.703-.464-.464-.464-.464-1.21-.464-2.703z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeLinecap: "round",
    strokeWidth: 1.583,
    d: "M3.543 7.914H16.21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E869E",
    d: "M12.12 7.125H7.634c-.186 0-.28 0-.338.058s-.058.151-.058.338v3.298c0 .606 0 .909.079 1.071a.79.79 0 0 0 .975.404c.17-.06.384-.274.812-.702.199-.198.298-.297.403-.353a.79.79 0 0 1 .74 0c.106.056.205.155.403.353.428.428.642.643.813.702.38.133.8-.04.975-.404.078-.162.078-.465.078-1.07v-3.3c0-.186 0-.28-.058-.337-.058-.058-.151-.058-.338-.058"
  })));
};
export default SvgMainProducts;